import { HouseSiding } from "@mui/icons-material";
import { SvgIconProps } from "@mui/material";

export const FarmIcon = (props: SvgIconProps) => (<HouseSiding {...props}/>);